var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidationsuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_354)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_166_354",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 164,
    height: 164
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 0H0V164H164V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_166_354)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_166_354",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -64,
    y: 0,
    width: 292,
    height: 164
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-63.7812 0H227.774V164H-63.7812V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_166_354)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_166_354",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -76,
    y: -25,
    width: 316,
    height: 214
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-75.8047 26.5561L211.323 -24.0655L239.797 137.444L-47.3301 188.065L-75.8047 26.5561Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_166_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.8933 132.472C61.5968 134.345 35.5769 113.891 30.4799 84.9802L25.0968 54.447C39.5621 53.7208 52.8822 46.3569 61.1898 34.4927L61.8807 33.5061L84.3125 29.5513L85.2991 30.2422C97.1632 38.5499 112.198 40.9148 126.04 36.6503L131.423 67.1835C136.52 96.0939 119.064 124.213 90.8933 132.472Z",
    stroke: "#00B077",
    strokeWidth: 8.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.233 77.5509C109.69 91.4883 100.384 104.779 86.4466 107.236C72.5093 109.693 59.2189 100.387 56.7617 86.4493C54.3045 72.5119 63.611 59.2215 77.5483 56.7643C91.4856 54.3071 104.776 63.6136 107.233 77.5509Z",
    stroke: "#00B077",
    strokeWidth: 8.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5313 83.6677L79.9525 88.8643C79.9525 88.8643 87.8028 77.6535 89.8581 74.7184",
    stroke: "#00B077",
    strokeWidth: 8.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 164,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationsuccess);
export default __webpack_public_path__ + "static/media/validationsuccess.d73327de359140b665e920f9d48c0535.svg";
export { ForwardRef as ReactComponent };